import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { rootRoute } from '../../../router/routes/rootRoute';

import { simpleSearchResultFormSchema } from './helpers/simpleSearchResultFormSchema';

export const simpleSearchResultRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/simple-search-result',
	validateSearch: simpleSearchResultFormSchema,
	component: lazyRouteComponent(
		() => import('./SimpleSearchResultPage'),
		'SimpleSearchResultPage',
	),
});
